export default "__VITE_ASSET__ac424220__"